export default "__VITE_ASSET__cAIz6dEl__"